module.exports = __webpack_public_path__ + "static/media/undraw_customer_survey_f9ur.9c76608e.svg";